module.exports = __webpack_public_path__ + "static/img/Homev34.c834e27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/Homev34.png
// module id = UR26
// module chunks = 0